import declination from "../../../utils/declination";

const getNumberOfApplications = (applicationsNumber) => {
  const word = declination(applicationsNumber, ['заявка', 'заявки', 'заявок'])
  return `${applicationsNumber} ${word}`
}

export default getNumberOfApplications;
